/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSubcategoryLookupDto
 */
export interface UpdateSubcategoryLookupDto {
    /**
     * Unique sub-category code
     * @type {string}
     * @memberof UpdateSubcategoryLookupDto
     */
    code?: string;
    /**
     * Sub-category name in English
     * @type {string}
     * @memberof UpdateSubcategoryLookupDto
     */
    nameEn?: string;
    /**
     * Arabic name of the sub-category
     * @type {string}
     * @memberof UpdateSubcategoryLookupDto
     */
    nameAr?: string;
    /**
     * Description of the sub-category
     * @type {string}
     * @memberof UpdateSubcategoryLookupDto
     */
    description?: string;
    /**
     * Whether the sub-category is active
     * @type {boolean}
     * @memberof UpdateSubcategoryLookupDto
     */
    isActive?: boolean;
    /**
     * Sort order for display
     * @type {number}
     * @memberof UpdateSubcategoryLookupDto
     */
    sortOrder?: number;
    /**
     * Parent category lookup ID
     * @type {number}
     * @memberof UpdateSubcategoryLookupDto
     */
    categoryLookupId?: number;
}

/**
 * Check if a given object implements the UpdateSubcategoryLookupDto interface.
 */
export function instanceOfUpdateSubcategoryLookupDto(value: object): value is UpdateSubcategoryLookupDto {
    return true;
}

export function UpdateSubcategoryLookupDtoFromJSON(json: any): UpdateSubcategoryLookupDto {
    return UpdateSubcategoryLookupDtoFromJSONTyped(json, false);
}

export function UpdateSubcategoryLookupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSubcategoryLookupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'nameEn': json['nameEn'] == null ? undefined : json['nameEn'],
        'nameAr': json['nameAr'] == null ? undefined : json['nameAr'],
        'description': json['description'] == null ? undefined : json['description'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'categoryLookupId': json['categoryLookupId'] == null ? undefined : json['categoryLookupId'],
    };
}

export function UpdateSubcategoryLookupDtoToJSON(value?: UpdateSubcategoryLookupDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'code': value['code'],
        'nameEn': value['nameEn'],
        'nameAr': value['nameAr'],
        'description': value['description'],
        'isActive': value['isActive'],
        'sortOrder': value['sortOrder'],
        'categoryLookupId': value['categoryLookupId'],
    };
}

